import clsx from 'clsx';
import {
  AgxCaption,
  AgxColumn,
  AgxLabel,
  AgxRow,
  CampaignStage,
  BasicCampaignDetailModel,
  useWindowSize,
  Breakpoints,
} from '@urbanx/agx-ui-components';
import { cleanTwoLineAddressWithoutState } from 'utils/formatAddress';
import { getMomentFromNow } from 'utils/utcDateFromNow';
import placeHolderImage from '../../../../../assets/images/placeholder-property.png';
import { getEnumValue } from 'helpers/enumHelper';
import './CampaignsViewPageImageCard.scss';
import { useMemo } from 'react';

export const CampaignsViewPageImageCard = ({
  onClick,
  campaign,
  index,
  selected,
}: {
  onClick: () => void;
  campaign: BasicCampaignDetailModel;
  index: number;
  selected: boolean;
}) => {
  const { stage, address, propertyImageUrls, lastUpdated, completionState } = campaign;

  const [addressLineOne, addressLineTwo] = useMemo(
    () => cleanTwoLineAddressWithoutState(address),
    [address]
  );

  const image = propertyImageUrls?.thumbnail;

  const breakpoint = useWindowSize();

  const isSmallDevice = useMemo(
    () =>
      breakpoint === Breakpoints.Mobile ||
      breakpoint === Breakpoints.Tablet_Landscape ||
      breakpoint === Breakpoints.Tablet_Portrait,
    [breakpoint]
  );

  const cardClasses = useMemo(
    () => clsx('propertyViewImageCard', 'gapOther', 'cursorPointer', selected && 'selected'),
    [selected]
  );

  return (
    <AgxRow onClick={onClick} extraClasses={cardClasses} fill centered>
      <img
        className={completionState?.completionType ? 'archived' : ''}
        src={image ?? placeHolderImage}
        alt="Property"
      />
      <AgxColumn spaceBetween fill centerJustified extraClasses="propertyCardDetails">
        <AgxCaption
          dataTestId={`agx-campaignStage-${index}`}
          small={isSmallDevice}
          extraClasses={'lightText'}
        >
          {getEnumValue(CampaignStage, stage)}
        </AgxCaption>
        <AgxCaption
          dataTestId={`agx-campaignDate-${index}`}
          small={isSmallDevice}
          extraClasses="lightText date"
        >
          {getMomentFromNow(lastUpdated.toString())}
        </AgxCaption>

        <AgxLabel extraClasses={'campaignListAddress'} dataTestId={`agx-campaignAddress-${index}`}>
          {addressLineOne} <br /> {addressLineTwo}
        </AgxLabel>
      </AgxColumn>
    </AgxRow>
  );
};
